import React from 'react';
import {
  CloudUpload, PenTool, MousePointer2, Eraser
} from 'lucide-react';
import { motion } from 'framer-motion';

const DesignToolbox = ({ activeTool, onToolSelect, onAction }) => {
  const tools = [
    { id: 'select', icon: MousePointer2, label: 'Select' },
    { id: 'draw', icon: PenTool, label: 'Pencil', color: 'text-blue-500' },
    { id: 'image', icon: CloudUpload, label: 'Upload', color: 'text-lux-gold' },
    { id: 'eraser', icon: Eraser, label: 'Eraser', color: 'text-red-500' },
  ];

  return (
    <div className="flex z-20 h-full">
      {/* Primary Sidebar Rail */}
      <div className="w-[84px] bg-white border-r border-lux-border flex flex-col items-center py-6 gap-2 shadow-[4px_0_24px_rgba(0,0,0,0.02)]">
        {tools.map((tool) => (
          <button
            key={tool.id}
            onClick={() => onToolSelect(tool.id)}
            className={`w-16 h-16 flex flex-col items-center justify-center rounded-xl transition-all duration-300 group ${activeTool === tool.id
                ? 'bg-lux-bg text-lux-primary'
                : 'text-lux-secondary hover:bg-lux-bg/50 hover:text-lux-primary'
              }`}
          >
            <div className="relative">
              <tool.icon size={22} className={tool.color} strokeWidth={activeTool === tool.id ? 2 : 1.5} />
            </div>
            <span className="text-[10px] mt-2 font-medium tracking-tight opacity-70 group-hover:opacity-100 transition-opacity">
              {tool.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DesignToolbox;
